export { usd as money } from "./money";

// "resets at 8:00 PM today your time (midnight UTC)" — the next UTC midnight shown in the viewer's own clock.
export const resetLabel = (iso, now = new Date()) => {
  if (!iso) return "";
  const at = new Date(iso);
  const time = at.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  return `resets at ${time} ${at.toDateString() === now.toDateString() ? "today" : "tomorrow"} your time (midnight UTC)`;
};
